import type { AdmitStudentInput, AdmitStudentOutput } from './schemas'
import type { StudentPayload } from './api'
import type { StudentDetail } from './types'

export function toPayload(v: AdmitStudentOutput): StudentPayload {
  return {
    admissionNumber: v.admissionNumber,
    firstName: v.firstName,
    lastName: v.lastName,
    gender: v.gender,
    dateOfBirth: v.dateOfBirth,
    bloodGroup: v.bloodGroup,
    religion: v.religion,
    nationality: v.nationality,
    email: v.email,
    phone: v.phone,
    address: v.address,
    medicalNotes: v.medicalNotes,
    photoFileId: v.photoFileId,
    guardians: v.guardians.map((g) => ({ ...g })),
  }
}

export function toFormValues(s: StudentDetail): AdmitStudentInput {
  return {
    admissionNumber: s.summary.admissionNumber,
    firstName: s.summary.firstName,
    lastName: s.summary.lastName,
    gender: s.summary.gender,
    dateOfBirth: s.summary.dateOfBirth ?? '',
    bloodGroup: s.bloodGroup ?? '',
    religion: s.religion ?? '',
    nationality: s.nationality ?? '',
    email: s.email ?? '',
    phone: s.summary.phone ?? '',
    address: s.address ?? '',
    medicalNotes: s.medicalNotes ?? '',
    photoFileId: null,
    guardians: s.guardians.map((g) => ({
      id: g.id,
      relation: g.relation,
      name: g.name,
      phone: g.phone ?? '',
      email: g.email ?? '',
      occupation: g.occupation ?? '',
      isPrimary: g.isPrimary,
    })),
    classId: '',
    sectionId: '',
    rollNumber: '',
    admissionDate: s.summary.admissionDate,
  }
}
